var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentDisputedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#F2994A",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50488 4.59277C6.05905 4.43975 6.88836 4.41697 7.94238 5.02441C9.54852 5.95008 10.786 5.64914 11.4512 5.32227V9.30078C11.2066 9.41167 10.7244 9.60352 10.1631 9.6748C9.54391 9.75338 8.86393 9.68408 8.29297 9.24512C7.42488 8.57761 6.39803 8.59146 5.63086 8.74805C5.28395 8.81885 4.97945 8.92107 4.74902 9.01172V4.9541C4.77917 4.93195 4.81491 4.90457 4.8584 4.87695C5.00471 4.78403 5.22316 4.67057 5.50488 4.59277Z",
    stroke: "white",
    strokeWidth: 0.631531
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.43359,
    y: 5.01953,
    width: 0.6875,
    height: 7.5,
    rx: 0.34375,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDisputedIcon);
export default __webpack_public_path__ + "static/media/PaymentDisputedIcon.7b5af61c6f48ca51b46bfaf11dc57b97.svg";
export { ForwardRef as ReactComponent };